import React, { useState } from "react";
import HttpApiUtil from "../../../../ApiUtils/HttpApiUtil";
import PendingStatus from "../Android/PendingStatus";
import ProcessingPaymentScreen from "../Android/ProcessingPaymentScreen";
import FailedPayment from "../Android/FailedPayment";
import SuccessPage from "../Android/successPage";
import GenerateQR from "./GenerateQr";
import { useSelector } from "react-redux";

const ObjHttpApiUtil = new HttpApiUtil();

const WebScreen = ({ data = {},screen, setScreen,checkStatus, getUpiLink, clearVpa, hideCollectFlow }) => {
  const merchnatReturnUrl = useSelector(
    (state) =>
      state?.merchantPaymentDataFetchingReducer?.merchantPaymentData
        .merchant_data?.merchant_return_url || window.location.pathname
  );
  const token = useSelector(
    (state) => state.merchantPaymentDataFetchingReducer.token
  );
  const handleScreen = () => {
    switch (screen) {
      case "PENDING_STATUS":
        return <PendingStatus setScreen={setScreen} />;
      case "TIMER_PROCESSING":
        return (
          <ProcessingPaymentScreen
            transactionId={data.pine_pg_transaction_id}
            setScreen={setScreen}
            ObjHttpApiUtil={ObjHttpApiUtil}
            checkStatus={checkStatus}
          />
        );

      case "FAILED_PAYMENT":
        return <FailedPayment />;
      case "SUCCESS_PAGE":
        return (
          <SuccessPage
            merchnatReturnUrl={merchnatReturnUrl}
           
          />
        );
      default:
        return <GenerateQR 
          checkStatus={checkStatus} 
          data={data} setScreen={setScreen} 
          getUpiLink={getUpiLink} 
          clearVpa={clearVpa}
          hideCollectFlow={hideCollectFlow}
        />;
    }
  };

  return (
    <>
      {handleScreen()}
      <form
        id="UPIAuthForm"
        method="POST"
        action={
          process.env.REACT_APP_PG_CONTROLLER + "UPI/SubmitUpiTransaction"
        }
      >
        <input class="form-control" type="hidden" value={""} id="apitimeout" />
        <input
          class="form-control"
          type="hidden"
          name="token"
          value={token}
          id="PinePGTransactionID"
        />
      </form>
    </>
  );
};

export default WebScreen;
